import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    OnChanges,
    SimpleChanges,
} from "@angular/core";
import { Observable, Subject, Subscriber } from "rxjs";
import { switchMap, takeUntil } from "rxjs/operators";
import { NbcBaseComponent } from "../../../../core/component/Base.Component";
import {
    EmitEvent,
    EventBusService,
} from "../../../../core/services/event-bus.service";
import { NbcLoggerService } from "../../../../shared/logger/nbc-logger.service";
import { LookUpService } from "../../../../shared/services/lookup.service";

@Component({
    selector: "glaccount-template",
    templateUrl: "./glaccount-template.component.html",
    standalone: false
})
export class GlAccountTemplateComponent
    extends NbcBaseComponent
    implements OnInit, OnChanges
{
    constructor(
        private lookupService: LookUpService,
        private _eventBus: EventBusService,
        private log: NbcLoggerService
    ) {
        super();
    }

    @Input() model: any | undefined;
    @Input() name: string | undefined;
    @Input() mpId: string | undefined;
    @Input() nbcClass: string | undefined;
    @Input() isRequired = false;
    @Input() placeHolder: any | undefined;
    @Input() typeaheadOptionLimit: any = 10;
    @Input() nbcAuthenticateUser: any | undefined;
    @Input() nbcAuthenticateCommand: any | undefined;
    @Input() nbcAuthenticateDisabled: any | undefined;
    @Input() nbcAuthenticateRequired: any | undefined;
    @Input() nbcDisabled: any | undefined;
    @Input() isBulkUpdate = false;
    @Input() id: any | undefined;

    @Output() modelChange = new EventEmitter<any>();
    @Output() glAccountChange: EventEmitter<any> = new EventEmitter<any>();

    isAuthorized = true;
    glAccountObservable$: Observable<any[]> | undefined;
    componentDestroyed$: Subject<any> = new Subject();

    searchTerm = "";

    getGLAccounts() {
        this.log.trace("get GL Account");
        this.glAccountObservable$ = new Observable(
            (observer: Subscriber<string>) => {
                observer.next(this.searchTerm);
            }
        ).pipe(
            takeUntil(this.componentDestroyed$),
            switchMap((token: string) => {
                return this.lookupService.searchGlAccounts(
                    encodeURIComponent(token)
                );
            })
        );
    }

    EmitModelData() {
        this.modelChange.emit(this.searchTerm);

        const data = {
            mpId: this.id,
            glAccount: this.searchTerm,
        };
        this.glAccountChange.emit(data);
    }

    onValueSelected($event) {
        const glAccount = $event.item;
        this.modelChange.emit(glAccount);

        const data = {
            mpId: this.id,
            glAccount: glAccount,
        };
        this.glAccountChange.emit(data);
        this._eventBus.emit(
            new EmitEvent(
                "glaccount-template:glaccountSelected",
                "onglValueSelected",
                data
            )
        );
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === "model") {
                const current = changes["model"]["currentValue"];
                const prev = changes["model"]["previousValue"];
                this.model = current;
                this.searchTerm = this.model;
            }
        }
    }

    ngOnInit() {
        this.searchTerm = this.model;
        this.getGLAccounts();

        if (!this.nbcDisabled)
            this.isAuthorized = this.authorize(this.nbcAuthenticateUser);
    }
}
